module.exports = __webpack_public_path__ + "static/media/04-02.47da78a8.png";